import { render, staticRenderFns } from "./ModulosServentia.vue?vue&type=template&id=1c7d25e8&"
import script from "./ModulosServentia.vue?vue&type=script&lang=js&"
export * from "./ModulosServentia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports